//TODO: generalize this so its reusable across app
import React, {Component} from 'react'
import Autosuggest from 'react-autosuggest';

// Imagine you have a list of languages that you'd like to autosuggest.


// Teach Autosuggest how to calculate suggestions for any given input value.

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;

// Use your imagination to render suggestions.
const renderSuggestion =  function(suggestion, {query, isHighlighted}){

  let highlightedClass = isHighlighted ? 'hightlighted-selection' : '';
return (

  <div>
    <small className={highlightedClass}> {suggestion.name}</small>
  </div>
);

}
 export default class AutoSuggestTags extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value:"",
      suggestions: []
    };

    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.getSuggestion = this.getSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.fetchTags = this.fetchTags.bind(this);
  };


  onChange(e, args){


    let newValue = args.newValue;
    this.setState({
      value: newValue
    });

  }



  getSuggestions(value){
   const inputValue = value.trim().toLowerCase();
   const inputLength = inputValue.length;
   let tags = this.state.tags;
    return inputLength === 0 ? [] : tags.filter(tag =>
    tag.name.toLowerCase().slice(0, inputLength) === inputValue
    );
  };


  componentDidMount(){

  }

  componentWillMount(){
    this.fetchTags();
  }

  fetchTags(){
    var t = this;
    var url = null;

    if (this.props.endpoint) {
      url =  this.props.endpoint
    }
    url = url || Routes.rmrc_ad_all_tags_path();
    
    t.setState({loading: true});
    $.ajax({
      method: 'GET',
      url: url,
      dataType: 'JSON',
      success: function(data, statusText, xhr){
        t.setState({tags: data['tags']});
        t.setState({value: ''});

      },
      error: function(data, statusText, xhr){
        console.log(data);

      }
    });
  }

  onSuggestionSelected(value, args){

     this.setState({value: ''});
     this.props.onSuggestionSelected(value, args.suggestion);

  }


  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested(args){
    let value = args.value;
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested(){
    this.setState({
      suggestions: []
    });
  }

  onKeyDown(e){
    if (e.keyCode != 8. || this.state.value.length == 0){
      this.props.inputProps.onKeyDown(e);
    }


  }



  render() {
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
     const inputProps = {
      placeholder: 'Find a tag...',
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown
    };

    // Finally, render it!
    return (

     <div className="auto-suggest-tags">
      <Autosuggest

        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={this.onSuggestionSelected}
        inputProps={inputProps}
      />
     </div >

    );
  }
}




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/components/auto_suggest_tags.jsx